export default __webpack_public_path__ + "static/media/mail.5d8951a4.png";